import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a stack of five books (~0.25 m high), each a thin
// box slightly rotated against the next, in muted contemporary colours.
const BOOK_A = "#8a9aa8";
const BOOK_B = "#a05a40";
const BOOK_C = "#7a5a3a";
const BOOK_D = "#5f8f4e";
const BOOK_E = "#e8e4dc";

export const bookStack = defineModel({
  id: "book-stack",
  batchId: "modern",
  name: "Book stack",
  tags: ["modern", "interior", "decor", "books", "living-room"],
  summary: "A stack of five muted-coloured books.",
  tiles: { w: 1, h: 1 },
  footprint: 0.4,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(0.24, 0.05, 0.17), color: BOOK_A, position: [0, 0.025, 0], rotation: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.05, 0.16), color: BOOK_B, position: [0.01, 0.075, 0], rotation: [0, -0.18, 0] },
      { geometry: new THREE.BoxGeometry(0.23, 0.05, 0.16), color: BOOK_C, position: [-0.01, 0.125, 0.01], rotation: [0, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.21, 0.05, 0.15), color: BOOK_D, position: [0.01, 0.175, -0.01], rotation: [0, -0.08, 0] },
      { geometry: new THREE.BoxGeometry(0.19, 0.045, 0.14), color: BOOK_E, position: [0, 0.222, 0], rotation: [0, 0.3, 0] },
    ];
  },
  animations: [],
});
